import React, { useEffect } from "react";
import useGigs from "../../hooks/useGigs";
import moment from "moment-timezone";
import scratch from "../../scratch.png";
import { times } from "lodash";
import { Container, Placeholder, Row, Button } from "react-bootstrap";
import classNames from "classnames";

const Gigs = ({ inPast = false, pageSize = 250, onFetch }) => {
  console.log("Gigs pageSize prop:", pageSize);

  const { gigs, loading, showMore, totalGigs, updatePageSize } = useGigs({
    inPast,
    pageSize,
  });

  useEffect(() => {
    if (onFetch) {
      onFetch(totalGigs);
    }
  }, [totalGigs]);

  useEffect(() => {
    updatePageSize(pageSize);
  }, [pageSize]);

  if (!loading && inPast && gigs.length === 0 && totalGigs > 0) {
    return (
      <Button
        className="secondary-text fs-4"
        variant="link"
        onClick={() => {
          showMore(5);
        }}
      >
        Show past gigs ({totalGigs})
      </Button>
    );
  }

  if (!loading && !gigs?.length) {
    return <h2>No {inPast ? "Past" : "Upcoming"} Gigs</h2>;
  }

  return (
    <div className={`gigs-container ${inPast ? "past" : "upcoming"}`}>
      <h3>
        <span className={`${inPast && "secondary-text"}`}>
          {inPast ? "~ Past gigs ~" : "Upcoming gigs"}
        </span>
      </h3>

      {loading &&
        times(3, (i) => (
          <Placeholder
            key={`placeholder-${i}`}
            as="div"
            animation="glow"
            className="text-start d-flex p-2"
          >
            <div className="w-25">
              <Placeholder as="div" style={{ width: 84, height: 110 }} />
            </div>
            <div className="w-75">
              <Container>
                <Row className="mb-3">
                  <Placeholder as="col" style={{ minHeight: 2 }} />
                </Row>
                <Row className="mb-3">
                  <Placeholder as="col" xs={12} />
                </Row>
                <Row className="mb-3">
                  <Placeholder as="col" xs={4} />
                </Row>
                <Row className="mb-3">
                  <Placeholder as="col" xs={3} />
                </Row>
                <Row>
                  <Placeholder as="col" style={{ minHeight: 2 }} />
                </Row>
              </Container>
            </div>
          </Placeholder>
        ))}

      {gigs.map((gig, i) => {
        const todaysDate = moment(new Date())
          .tz("America/Los_Angeles")
          .format("M/D/yyyy");

        const gigDate = moment(gig.start.dateTime)
          .tz("America/Los_Angeles")
          .format("M/D/yyyy");

        const isToday = todaysDate === gigDate;

        const iconClasses = classNames({
          "gig-info": true,
          h5: true,
          first: i === 0,
          // "border-blink": i === 0,
        });

        return (
          <div key={gig.id} className="gig-row">
            <div className="gig-date">
              <div
                className="gig-weekday secondary-text"
                style={{
                  backgroundPosition: `${i * 20}px ${i + 2}px`,
                }}
              >
                {moment(gig.start.dateTime)
                  .tz("America/Los_Angeles")
                  .format("dddd")}
              </div>

              <div className="gig-month">
                {moment(gig.start.dateTime)
                  .tz("America/Los_Angeles")
                  .format("MMM")}
              </div>

              <div className="gig-day">
                {moment(gig.start.dateTime)
                  .tz("America/Los_Angeles")
                  .format("D")}
              </div>
              <div className="small gig-year">
                {moment(gig.start.dateTime)
                  .tz("America/Los_Angeles")
                  .format("yyyy")}
              </div>
            </div>

            <div className={iconClasses}>
              <a
                href={`http://maps.google.com/?q=${gig.summary} - ${gig.location}`}
                target="_blank"
              >
                <div style={{ fontSize: "larger" }}>{gig.summary}</div>
                <div style={{ fontSize: "medium", paddingTop: 5 }}>
                  <i className="bi bi-geo-alt-fill"></i>
                  <span style={{}}>{gig.location}</span>
                </div>
              </a>
              <div
                className="small secondary-text"
                style={{
                  paddingTop: "10px",
                  fontWeight: "bold",
                }}
              >
                {moment(gig.start.dateTime)
                  .tz("America/Los_Angeles")
                  .format("h:mm")}
                -
                {moment(gig.end.dateTime)
                  .tz("America/Los_Angeles")
                  .format("h:mma")}
              </div>

              {isToday && <div className="today">today</div>}
            </div>
          </div>
        );
      })}

      {!loading && gigs?.length < totalGigs && inPast && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Button
            className="secondary-text fs-4"
            variant="link"
            onClick={() => {
              // show more gigs
              showMore(totalGigs);
            }}
          >
            Show all ({totalGigs})
          </Button>
        </div>
      )}
    </div>
  );
};

export default Gigs;
